"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const documentContext = (0, react_1.createContext)(null);
exports.default = documentContext;
